import { render } from "./PaymentForm.vue?vue&type=template&id=38678289&scoped=true"
import script from "./PaymentForm.vue?vue&type=script&lang=js"
export * from "./PaymentForm.vue?vue&type=script&lang=js"

import "./PaymentForm.vue?vue&type=style&index=0&id=38678289&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\ihcpayment\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38678289"]])

export default __exports__